import { render, staticRenderFns } from "./StatisticsUsersGraph.vue?vue&type=template&id=6b22f740&scoped=true&"
import script from "./StatisticsUsersGraph.vue?vue&type=script&lang=js&"
export * from "./StatisticsUsersGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22f740",
  null
  
)

export default component.exports